import React, { FC } from 'react';
import { StyledFlexContainer } from 'shared/ui/styled-components';
import { LocalizedHeading } from 'shared/ui/localized-heading';
import { StyledProductLogoFigure, StyledProductLogoImage } from './styled';

interface Props {
    logo: string;
    localizationPath: string;
    headerKeys: string[];
}

export const ContentHeader: FC<Props> = ({ logo, localizationPath, headerKeys }) => {
    return (
        <StyledFlexContainer $align="center" $direction="row" $gap="24px">
            <StyledProductLogoFigure>
                <StyledProductLogoImage alt="Logo" src={logo} />
            </StyledProductLogoFigure>
            <StyledFlexContainer $direction="column" $flex="1">
                {headerKeys.map(headerKey => (
                    <LocalizedHeading
                        key={headerKey}
                        localizationKey={`${localizationPath}.${headerKey}`}
                        type="H4"
                    />
                ))}
            </StyledFlexContainer>
        </StyledFlexContainer>
    );
};
